module.exports = __webpack_public_path__ + "img/f23.70d16ee1.jpg";